import { PoStorageService } from '@po-ui/ng-storage';

export interface IFiltroRelatorioMI {
  lastSetDefault: Date;
  CA1GRPVEN: string;
}

export class FiltroRelatorioMI {

  dados: IFiltroRelatorioMI;
  storageName: string;

  constructor(private poStorageService: PoStorageService) {

    this.dados = this.setDefault();
    this.storageName = 'interface-filtro-relatorio-MI';

    this.poStorageService.get(this.storageName).then((filtro: IFiltroRelatorioMI) => {
      if (filtro) {

        const {
          lastSetDefault,
        } = filtro;

        if (!lastSetDefault && (new Date().getDay() - new Date(lastSetDefault).getDay())) {
          this.dados = this.setDefault();
        } else {
          this.dados = {
            ...filtro,
            lastSetDefault: new Date(lastSetDefault),
          };
        }
      }
    });
  }

  public setDefault = (): IFiltroRelatorioMI => {
    return {
      lastSetDefault: new Date(),
      CA1GRPVEN: '',
    };
  }

  public setStorage = (): void => {
    this.poStorageService.set(this.storageName, this.dados);
  }

  private getData = (dias: number): Date => {
    const dataDe = new Date();
    dataDe.setDate(dataDe.getDate() + dias);
    return dataDe;
  }

}
